import '../styles/StatsSection.css';

// Edit these to your real numbers whenever you have them.
const STATS = [
  { value: '30,000,000+', label: 'unique active wallets' },
  { value: '180,000,000+', label: 'connections' },
  { value: '50,000+', label: 'apps' },
];

export default function StatsSection() {
  return (
    <section className="stats-section">
      <h2 className="stats-heading">By the numbers</h2>

      {STATS.map((stat) => (
        <div className="stat-row" key={stat.label}>
          <div className="stat-value">{stat.value}</div>
          <div className="stat-label">{stat.label}</div>
        </div>
      ))}
    </section>
  );
}